import React, { useState } from 'react';
import axios from 'axios';
import { contactApiService } from './contact-api';
import './ContactForm.css';

interface ContactFormProps {
  variant?: 'float' | 'inline';
}

const ContactForm: React.FC<ContactFormProps> = ({ variant = 'float' }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [inquiry, setInquiry] = useState('');
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('submitting');
    setErrorMessage('');
    try {
      const response = await contactApiService.submit({
        name,
        email,
        inquiry: inquiry || undefined,
      });
      if (response.error) {
        setStatus('error');
        setErrorMessage(response.error);
        return;
      }
      setStatus('success');
      setName('');
      setEmail('');
      setInquiry('');
    } catch (err) {
      setStatus('error');
      const msg =
        axios.isAxiosError(err) && err.response?.data?.error
          ? err.response.data.error
          : err instanceof Error
            ? err.message
            : 'Failed to send message. Please try again.';
      setErrorMessage(msg);
    }
  };

  return (
    <form className={`contact-form contact-form--${variant}`} onSubmit={handleSubmit}>
      <h3 className="contact-form__title">Get in Touch</h3>
      <label className="contact-form__label">
        <span className="contact-form__label-text">Name <span className="contact-form__required">*</span></span>
        <input type="text" className="contact-form__input" value={name} onChange={(e) => setName(e.target.value)} required disabled={status === 'submitting'} placeholder="Your name" />
      </label>
      <label className="contact-form__label">
        <span className="contact-form__label-text">Work email <span className="contact-form__required">*</span></span>
        <input type="email" className="contact-form__input" value={email} onChange={(e) => setEmail(e.target.value)} required disabled={status === 'submitting'} placeholder="you@company.com" />
      </label>
      <label className="contact-form__label">
        <span className="contact-form__label-text">Inquiry <span className="contact-form__optional">(optional)</span></span>
        <textarea className="contact-form__textarea" value={inquiry} onChange={(e) => setInquiry(e.target.value)} disabled={status === 'submitting'} placeholder="Tell us how we can help" rows={3} />
      </label>
      {status === 'success' && <p className="contact-form__message contact-form__message--success">Thanks! We&apos;ll be in touch soon.</p>}
      {status === 'error' && <p className="contact-form__message contact-form__message--error">{errorMessage}</p>}
      <button type="submit" className="contact-form__submit" disabled={status === 'submitting'}>
        {status === 'submitting' ? 'Sending...' : 'Submit'}
      </button>
    </form>
  );
};

export default ContactForm;
